import { Bookmark, X, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

function formatDateTime(isoString) {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleDateString("sv-SE", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit"
  });
}

export function BookingSelectionDialog({
  open,
  onOpenChange,
  bookings,
  onSelectBooking,
  onSkip,
}) {
  if (!bookings || bookings.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Bookmark className="h-5 w-5 text-amber-500" />
            Avbokning?
          </DialogTitle>
          <DialogDescription>
            Produkten har aktiva bokningar. Vill du avboka någon av dem?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4 max-h-[300px] overflow-y-auto">
          {bookings.map((booking) => (
            <button
              key={booking.id}
              onClick={() => onSelectBooking(booking)}
              className="w-full p-4 rounded-lg bg-amber-500/10 border border-amber-500/30 hover:border-amber-500 transition-colors text-left"
              data-testid={`booking-option-${booking.id}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <Badge variant="outline" className="border-amber-500 text-amber-500">
                      {booking.quantity} st
                    </Badge>
                    {booking.location && (
                      <Badge variant="secondary" className="font-mono text-xs">
                        {booking.location}
                      </Badge>
                    )}
                  </div>
                  <p className="font-medium text-sm">{booking.comment}</p>
                  <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
                    <span>{formatDateTime(booking.booked_at)}</span>
                    {booking.booked_by && (
                      <>
                        <span>•</span>
                        <span>av {booking.booked_by}</span>
                      </>
                    )}
                  </div>
                </div>
                <ArrowRight className="h-5 w-5 text-amber-500 shrink-0" />
              </div>
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-2">
          <Button 
            variant="outline" 
            onClick={onSkip}
            className="w-full"
            data-testid="skip-booking-btn"
          >
            <X className="h-4 w-4 mr-2" />
            Nej, behåll bokningar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
